<template>
    <section>
        <b-overlay :show="loadingTriggerList" no-wrap opacity="1">
        </b-overlay>
        <PageTitle :main="$t('rtaTriggerList')" sub="" imagem="pop2.png" />
        <section>
            <section>
                <Filters @filter-changed="loadOpenTriggers" @filter-reset="resetFilters" :headerToExport="tableColumns"
                    :dataToExport="tableData" fileName="Lista de Gatilhos RTAs" :showExport="true" />
            </section>
            <section>
                <Table :tableColumns="tableColumns" :tableData="tableData" :priorize-func="askOpenRta"
                    :justify-func="justifyrta" :hideColsArr="[]"/>
            </section>
            <Overview :filters="overviewFilters"/>

        </section>
        <b-modal id="justifyTriggerModal" title="Justificar RTA" hide-footer>
            <textarea :disabled="!canJustify" class="justifyClass" v-model="justifyTxt"
                @input="e => justifyTxt = e.target.value" placeholder="Digite sua Justificativa"></textarea>
            <RtaModalButtons v-if="canJustify" :ok-func="handleJustify"
                :cancel-func="() => this.$bvModal.hide('justifyTriggerModal')" />
        </b-modal>

        <b-modal id="openRtaModal" title="Abrir RTA" hide-footer>
            <p>Tem certeza que deseja abrir uma RTA para este disparo gatilho?</p>
            <RtaModalButtons :ok-func="openRtaFromTrigger" :cancel-func="() => this.$bvModal.hide('openRtaModal')" />
        </b-modal>
    </section>
</template>

<script>
import PageTitle from "../template/PageTitle.vue";
import Filters from "./commons/Filters.vue";
import Table from "./commons/Table.vue";
import Overview from "./commons/Overview.vue";
import axios from 'axios';
import { defaultSuccess, showError, urlMainAPI } from '../../global';
import RtaModalButtons from "./commons/RtaModalButtons.vue";
import * as moment from 'moment'
export default {
    name: "TriggerRTA",
    components: { PageTitle, Filters, Table, RtaModalButtons, Overview },
    data() {
        return {
            loadingTriggerList: false,
            justifyTxt: "",
            justifyId: null,
            canJustify: false,
            keepFilters: null,
            openRtaObj: null,
            defaultFilters: {
                processId: null,
                workshiftId: null,
                startDate: "",
                endDate: "",
            },
            tableColumns: [
                { field: "creationDate", key: 'creationDate', title: 'Data do Disparo', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "indicator", key: 'indicator', title: 'Indicador', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "process", key: 'process', title: 'Processo', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "workshift", key: 'workshift', title: 'Turno', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "trigger", key: 'trigger', title: 'Gatilho', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "responsible", key: 'responsible', title: 'Responsável', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "lowerLimit", key: 'lowerLimit', title: 'Limite Inferior', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "upperLimit", key: 'upperLimit', title: 'Limite Superior', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "prevValue", key: 'prevValue', title: 'Valor Previsto', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "realValue", key: 'realValue', title: 'Valor Real', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "priorizerta", key: 'priorizerta', title: 'Priorizar', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "justifyrta", key: 'justifyrta', title: 'Justificar', align: "center", sortBy: "", width: "8%", ellipsis: { lineClamp: 1 } },
            ],
            tableData: [],
            overviewFilters:null,
        }
    },
    methods: {
        async resetFilters() {
            await this.loadOpenTriggers(this.defaultFilters);
        },

        askOpenRta(obj) {
            this.openRtaObj = obj;

            this.$bvModal.show('openRtaModal');
        },

        async openRtaFromTrigger() {
            this.$bvModal.hide('openRtaModal');
            if (this.openRtaObj == null) return;

            this.loadingTriggerList = true;

            let date = new Date();

            let rtaToSave = [
                {
                    id: -9999,
                    rtaCode: "",
                    indicatorId: this.openRtaObj.indicatorId,
                    processId: this.openRtaObj.processId,
                    workshiftId: this.openRtaObj.workshiftId,
                    productId: this.openRtaObj.productId,
                    equipmentId: this.openRtaObj.equipmentId,
                    triggerId: this.openRtaObj.triggerId,
                    lowerLimit: this.openRtaObj.lowerLimit,
                    upperLimit: this.openRtaObj.upperLimit,
                    target: this.openRtaObj.target,
                    value: this.openRtaObj.value,
                    creationDate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss"),
                    deadline: moment(date.setDate(date.getDate() + 7)).format("YYYY-MM-DDTHH:mm:ss"),
                    actionPlanResponsibleId: null,
                    accuracyResponsibleid: null,
                    generalResponsibles: "",
                    relatedRtaId: null,
                    efficiencyRTAId: null,
                    status: 0,
                    lastUpdate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss"),
                }
            ];

            let rtaDetails = {}

            await axios.post(`${urlMainAPI}/saverta/${true}`, rtaToSave)
                .then((res) => {
                    rtaDetails = { ...res.data[0] }
                    rtaDetails.code = res.data[0].rtaCode;
                    rtaDetails.auxResponsibles = res.data[0].generalResponsibles;
                    rtaDetails.mainRespId = res.data[0].actionPlanResponsibleId;
                    rtaDetails.efficiencyRespId = res.data[0].accuracyResponsibleid;
                    rtaDetails.trigger = this.openRtaObj.trigger;
                    rtaDetails.description = "";

                    rtaDetails.formattedCreationDate = moment(res.data[0].creationDate).format("YYYY-MM-DD");
                    rtaDetails.formattedDeadline = moment(res.data[0].deadline).format("YYYY-MM-DD");

                    defaultSuccess("RTA Criada com Sucesso!")
                })
                .catch(() => showError("Falha ao Abrir RTA."))

            let justify = "";
            await axios.post(`${urlMainAPI}/justifyrta/${this.openRtaObj.id}/${false}`, JSON.stringify(justify), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            this.loadingTriggerList = false;

            this.$router.push({ name: "rtadetails", params: { rtaId: rtaDetails.rtaCode, rtaData: rtaDetails, isManual: false } }).catch(err => console.error(err));
        },

        justifyrta(obj) {
            if (obj.refuseJustification == "") {
                this.canJustify = true;
            } else {
                this.canJustify = false;
                this.justifyTxt = obj.refuseJustification;
            }

            this.justifyId = obj.id;

            console.log("JUSTIFICOU RTA: ", obj)
            this.$bvModal.show("justifyTriggerModal");
        },

        async loadOpenTriggers(filters) {
            this.overviewFilters = filters;

            this.loadingTriggerList = true;
            this.keepFilters = { ...filters };

            let url = `${urlMainAPI}/getshoottriggersrta`;
            let queryMount = [];

            if (filters.processId != null && filters.processId != undefined) queryMount.push(`processId=${filters.processId}`);
            if (filters.workshiftId != null && filters.workshiftId != undefined) queryMount.push(`workshiftId=${filters.workshiftId}`);
            if (filters.startDate != null && filters.startDate != undefined && filters.startDate != "" && filters.startDate != "Data inválida") queryMount.push(`startDate=${filters.startDate}`);
            if (filters.endDate != null && filters.endDate != undefined && filters.endDate != "" && filters.endDate != "Data inválida") queryMount.push(`endDate=${filters.endDate}`);

            if (queryMount.length > 0) url += `?${queryMount.join("&")}`

            await axios.get(url)
                .then(res => {
                    if (res.status == 200) {
                        this.tableData = res.data;

                        if(res.data.length == 0) defaultSuccess('Nenhum gatilho encontrado.')
                        else  defaultSuccess('Gatilhos Carregados.')
                    }

                })
                .catch(() => showError("Falha ao Carregar Gatilhos."))

            this.loadingTriggerList = false;

        },

        async handleJustify() {
            this.$bvModal.hide("justifyTriggerModal");
            this.loadingTriggerList = true;

            let justify = this.justifyTxt;

            await axios.post(`${urlMainAPI}/justifyrta/${this.justifyId}/${true}`, JSON.stringify(justify), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(() => defaultSuccess("Gatilho Justificado com Sucesso!"))
                .catch(() => showError("Falha ao Justificar Gatilhos"))

            this.justifyTxt = "";
            this.loadingTriggerList = false;

            await this.loadOpenTriggers(this.keepFilters);
        },
    },
    async mounted() {
        await this.loadOpenTriggers(this.defaultFilters);
    },
}
</script>

<style scoped>
.justifyClass {
    width: 100%;
    padding: 0.3rem;
}
</style>